export default {
      id: "icon-white-down-arrow-icon-usage",
      viewBox: "0 0 16 11",
      url: __webpack_public_path__ + "img/icons.svg#icon-white-down-arrow-icon",
      toString: function () {
        return this.url;
      }
    }